import { ListItemIcon, ListItemText } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import MenuItemLoadingIndicator from '@/components/Menu/MenuItemLoadingIndicator';

const IsMakingSelectedFilesPublicMessage = () => (
  <>
    <ListItemIcon>
      <MenuItemLoadingIndicator />
    </ListItemIcon>
    <ListItemText>
      <FormattedMessage id="portfolio.challenge.files.add.select.making_selected_files_public_message" />
    </ListItemText>
  </>
);

export default IsMakingSelectedFilesPublicMessage;
